<template>
    <div id="video" v-wechat-title="$route.meta.title">
        <div class="banner-container">
            <div class="banner">
                <h2 class="title">视频教程</h2>
                <p class="description">深入浅出，带您了解蓝鲸产品</p>
                <div class="icon">
                    <img src="../../images/video/video.png" alt="video">
                </div>
            </div>
        </div>
        <section class="nav-container">
            <div :class="{ nav: true, fixed: isFixed }">
                <ul class="tutorial-list">
                    <template v-for="(item, index) in tutorialList">
                        <li
                            v-if="item.id === 3"
                            :key="index"
                            :class="{ tutorial: true, active: activeName === item.name }">
                        </li>
                        <li v-else :key="index" :class="{ tutorial: true, active: activeName === item.name }" @click="updateActiveTab(item.name)">
                            <span class="tutorial-name">{{ item.name }}</span>
                        </li>
                    </template>
                </ul>
            </div>
        </section>
        <section class="content-container">
            <div class="tutorial-list" :style="{ 'background-color': tutorialIndex % 2 === 0 ? '#f5f7fa' : '#ffffff' }" v-for="(tutorial, tutorialIndex) in activeTabList.children" :key="tutorialIndex">
                <div class="tutorial">
                    <p class="tutorial-label">{{tutorial.name}}</p>
                    <p class="tutorial-title">{{tutorial.desc}}</p>
                    <ul :class="matchStyle(tutorial.name).style">
                        <li
                            v-for="(videoItem, videoIndex) in tutorial.children"
                            :key="videoIndex"
                            class="video"
                            @click="openVideo(videoItem.url, videoItem.extra_info.is_play)">
                            <div class="cover"></div>
                            <div class="video-tag">{{ videoItem.extra_info.tag }}</div>
                            <div class="img" :style="{ background: `url('${videoItem.resource}') center/cover` }"></div>
                            <div class="name" :title="videoItem.name">{{ videoItem.name }}</div>
                            <div class="video-right">
                                <div class="name" :title="videoItem.name">
                                    <span>{{ videoItem.name }}</span>
                                </div>
                                <div class="tag-time">
                                    <span v-if="matchStyle(tutorial.name).isTag" :class="['tag', videoItem.extra_info.level === '新手' ? '' : 'advanced']">{{videoItem.extra_info.level}}</span>
                                    <span style="color:#C4C6CC" class="icon-time-2 icon"></span>
                                    <span class="time">{{videoItem.extra_info.duration  || '-- : --'}}</span>
                                </div>
                            </div>
                            <ul class="video-item" v-if="videoItem.children.length !== 0">
                                <li v-for="(item, index) in videoItem.children" :key="index" @click.stop="openVideo(item.url, item.extra_info.is_play)">
                                    <span style="font-size: 24px; color: #979ba5; margin-right: 16px" class="icon-bofang"></span>
                                    <span :title="item.name">{{ item.name }}</span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <el-dialog
            :visible.sync="showVideo"
            center
            :close-on-click-modal="false"
            :destroy-on-close="true"
            custom-class="pro-video-dialog"
            @close="handleClose">
            <video width="100%" :src="videoUrl" autoplay controls>
                抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 <a :href="videoUrl">下载</a>
                并用你喜欢的播放器观看!
            </video>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Video',
        data () {
            return {
                tutorialList: [],
                popVisible: false,
                menuList: [],
                tutorialInfo: {
                    id: null,
                    videoList: []
                },
                selectId: '',
                isFixed: false,
                activeName: '了解蓝鲸',
                videoUrl: '',
                showVideo: false
            }
        },
        computed: {
            activeTabList () {
                let activeList = []
                const list = this.tutorialList.find(item => item.name === this.activeName)
                activeList = list
                if (list && list.name === '主题沙龙') {
                    let edit = {
                        children: [],
                        desc: null,
                        extra_info: {},
                        name: '主题沙龙',
                        resource: null,
                        url: null
                    }
                    edit.children.push(list)
                    activeList = edit
                }
                return activeList || []
            }
        },
        created () {
            this.getVideoPage()
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll, { passive: true })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            async getVideoPage () {
                try {
                    axios.get(myUrl + 'page/layer/videos/info/').then(res => {
                        const resp = res.data.data
                        resp.children.forEach(item => {
                            if (item.id === 3) {
                                this.menuList = [{
                                    id: item.id,
                                    list: item.children
                                }]
                            }
                        })
                        this.tutorialList = resp.children
                        let initId = null
                        const { name } = this.$route.query
                        
                        if (name) {
                            this.activeName = name.split('-')[0]
                            this.selectId = name.split('-').slice(1).join('-')
                        } else {
                            this.activeName = '了解蓝鲸'
                        }
                        initId = this.activeName
                        if (this.selectId) {
                            initId = this.selectId.split('-')[0]
                            // 获取二层级联数据
                            const layerId = id.split('-')[0]
                            const menuId = id.split('-')[1]
                            const childId = id.split('-')[2]
                            if (childId) {
                                const index = this.menuList.findIndex(item => item.id === Number(layerId))
                                const info = this.menuList[index].list.find(item => item.id === Number(menuId))
                                this.handleMouseEnter(info, index)
                                initId = childId
                            }
                        }
                        this.getVideoList(initId)
                    })
                } catch (e) {
                    console.warn(e)
                }
            },
            matchStyle (name) {
                const mapStyle = [
                    { name: '品牌故事', style: 'video-list1'},
                    { name: '快速入门', style: 'video-list2'},
                    { name: '进阶实战', style: 'video-list3', isTag: true},
                    { name: 'SaaS 开发基础', style: 'video-list3'},
                    { name: 'SaaS 开发进阶', style: 'video-list3'},
                    { name: 'SaaS 开发实战', style: 'video-list3'},
                    { name: 'SaaS 开发框架', style: 'video-list3'},
                    { name: '二次开发实战场景', style: 'video-list4'},
                ]
                const cur = mapStyle.find(item => item.name === name)
                if (cur) return cur
                return { style: 'video-list' }
            },
            getVideoList (id, menu) {
                try {
                    id = Number(id)
                    if (menu) {
                        this.selectId = menu.id + '-' + id
                        this.activeName = this.menuList[0].id
                        const queryId = menu.id === Number(this.activeName) ? this.selectId : (this.activeName + '-' + this.selectId)
                        this.$router.push({
                            query: { id: queryId }
                        })
                    }
                    axios.get(myUrl + `page/layer/${id}/page_info/`).then(res => {
                        const resp = res.data.data
                        this.tutorialInfo = { id, videoList: resp }
                        this.popVisible = false
                    })
                } catch (e) {
                    console.warn(e)
                }
            },
            handleMouseEnter (info, index) {
                if (!info.children.length) {
                    this.menuList.splice(index + 1, 1)
                    return
                }
                const menu = {
                    id: info.id,
                    list: info.children
                }
                this.menuList.splice(index + 1, 1, menu)
            },
            updateActiveTab (name) {
                this.activeName = name
                this.selectId = ''
                this.$router.push({
                    query: { name }
                })
            },
            isMenuActive (id, index) {
                return (this.menuList[index+1] && this.menuList[index+1].id === id)
                    || this.selectId.split('-').includes(String(id))
            },
            handleScroll () {
                this.isFixed = window.scrollY >= 230
            },
            openVideo (url, isLocal) {
                if (!url) return
                if (!isLocal) {
                    window.open(url)
                    return
                }
                this.videoUrl = url
                this.showVideo = true
            },
            handleClose () {
                this.videoUrl = ''
                this.showVideo = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    #video {
        color: #333;
        > .banner-container {
            display: flex;
            width: 100%;
            height: 262px;
            overflow: hidden;
            background: linear-gradient(360deg, rgba(47, 48, 64, 1) 0%, rgba(42, 41, 53, 1) 100%);
            .banner {
                position: relative;
                width: 1180px;
                margin: 130px auto 40px;
                color: #fff;
                > .title {
                    color: #fff;
                    font-size: 38px;
                    font-weight: 500;
                    line-height: 53px;
                    margin: 0 0 13px;
                }
                > .description {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 26px;
                }
                > .icon {
                    position: absolute;
                    top: -24px;
                    right: -85px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > img {
                        width: 246px;
                        height: 114px;
                    }
                }
            }
        }
        > .nav-container {
            height: 96px;
            > .nav {
                width: 100%;
                height: 96px;
                padding: 24px 0;
                background: #fff;
                transition: all .2s;
                z-index: 10;
                &.fixed {
                    position: fixed;
                    top: 30px;
                    height: 80px;
                    padding-bottom:  10px;
                    transition: all .2s;
                    > .tutorial-list {
                        height: 60px;
                        transition: all .2s;
                    }
                }
                > .tutorial-list {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 48px;
                    width: 1180px;
                    margin: 0 auto;
                    transition: all .2s;
                    .tutorial {
                        position: relative;
                        display: flex;
                        align-items: center;
                        text-align: center;
                        // flex-shrink: 0;
                        // flex-grow: 1;
                        width: 142px;
                        height: 48px;
                        margin-right: 20px;
                        background: #fff;
                        border-radius: 24px;
                        cursor: pointer;
                        &:last-child {
                            margin-right: 0;
                        }
                        > .icon {
                            width: 26px;
                            height: 26px;
                            margin-left: 29px;
                            > img {
                                width: 26px;
                                height: 26px;
                            }
                        }
                        > .tutorial-name {
                            width: 160px;
                            // margin-left: 24px;
                            font-size: 16px;
                            font-weight: 500;
                            line-height: 22px;
                        }
                        > .anger-right-icon {
                            display: inline-block;
                            height: 25px;
                            width: 25px;
                            background: url('../../images/video/angle-right.png');
                            background-size: 100% 100%;
                        }
                        &.active, &:hover {
                            color: #fff;
                            background-color: #3a84ff;
                            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
                            transition: all .2s;
                            .doc-icon.icon-arrow-down-i {
                                color: #7980b8;
                                transition: all .2s;
                            }
                            .anger-right-icon {
                                background: url('../../images/video/angle-right1.png');
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
            }
        }
        > .content-container {
            padding-bottom: 140px;
            background: #f5f7fb;
            > .tutorial-list {
                width: 100%;
                > .tutorial {
                    width: 1180px;
                    margin: 0 auto;
                    padding: 48px 0;
                    .tutorial-label {
                        text-align: center;
                        font-family: PingFangSC-Semibold;
                        font-weight: 600;
                        font-size: 24px;
                        color: #000000;
                        text-align: center;
                    }
                    .tutorial-title {
                        text-align: center;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 16px;
                        color: #63656E;
                        text-align: center;
                        margin-top: 8px;
                    }
                    > .icon {
                        width: 40px;
                        height: 40px;
                        > img {
                            width: 40px;
                            height: 40px;
                        }
                    }
                    .video-label {
                        font-size: 20px;
                        font-weight: 400;
                        line-height: 40px;
                        text-align: center;
                        margin-top: 30px;
                    }
                    .video-desc {
                        font-size: 16px;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        color: #63656E;
                        line-height: 22px;
                        text-align: center;
                        margin-top: 8px;
                    }
                    .video-list {
                        display: grid;
                        flex-flow: wrap;
                        grid-template-columns: repeat(auto-fill,240px);
                        justify-content: space-between;
                        width: 1180px;
                        color: #fff;
                        .video {
                            width: 240px;
                            height: 237px;
                            margin: 40px 0px 0 0;
                            border-radius: 2px;
                            cursor: pointer;
                            overflow: hidden;
                            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                            background: #fff;
                            position: relative;
                            .video-right {
                                width: 240px;
                                height: 120px;
                                float: left;
                                padding: 0 16px;
                                position: absolute;
                                bottom: -80px;
                                .name {
                                    display: none;
                                }
                                .tag-time {
                                    height: 40px;
                                    width: 100%;
                                    .tag {
                                        padding: 2px 10px;
                                        height: 20px;
                                        color: #14A568;
                                        background: #E4FAF0;
                                        border: 1px solid rgba(20,165,104,0.30);
                                        border-radius: 2px;
                                        font-size: 12px;
                                    }
                                    .time {
                                        font-family: PingFangSC-Regular;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #979BA5;
                                    }
                                }
                            }
                            > .img {
                                width: 240px;
                                height: 120px;
                            }
                            .name {
                                width: 100%;
                                padding: 0 16px;
                                margin: 16px 0;
                                font-size: 16px;
                                color: #313238;
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                            }
                        }
                    }
                    .video-list4 {
                        display: grid;
                        flex-flow: wrap;
                        grid-template-columns: repeat(auto-fill,240px);
                        justify-content: space-between;
                        width: 1180px;
                        color: #fff;
                        .video {
                            width: 240px;
                            height: 237px;
                            margin: 40px 0px 0 0;
                            border-radius: 2px;
                            cursor: pointer;
                            overflow: hidden;
                            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                            background: #fff;
                            position: relative;
                            .cover {
                                position: absolute;
                                left: 0;
                                top: 0;
                                opacity: .5;
                                width: 100%;
                                height: 159px;
                                background: linear-gradient(180deg, rgba(66, 64, 97, 1) 0%, rgba(99, 98, 126, 1) 100%);
                            }
                            .img {
                                width: 240px;
                                height: 159px;
                            }
                            >.name {
                                position: absolute;
                                padding: 0 16px;
                                top: 85px;
                                left: 0;
                                font-family: TencentSansW7;
                            }
                            .video-tag {
                                position: absolute;
                                padding: 0 10px;
                                line-height: 22px;
                                height: 22px;
                                top: 0;
                                left: 0;
                                background-color: #ffe8c3;
                                font-size: 12px;
                                color: #FF9C01;
                                border-bottom-right-radius: 22px;
                            }
                            >.video-right {
                                width: 240px;
                                height: 84px;
                                float: left;
                                padding: 16px;
                                > .name {
                                    color: #313238;
                                    font-size: 16px;
                                    line-height: 25px;
                                    overflow:hidden;
                                    white-space:nowrap;
                                    text-overflow:ellipsis;
                                }
                                .tag-time {
                                    height: 24px;
                                    width: 100%;
                                    padding: 6px 0;
                                    .tag {
                                        padding: 2px 10px;
                                        height: 20px;
                                        color: #14A568;
                                        background: #E4FAF0;
                                        border: 1px solid rgba(20,165,104,0.30);
                                        border-radius: 2px;
                                        font-size: 12px;
                                    }
                                    .time {
                                        font-family: PingFangSC-Regular;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #979BA5;
                                    }
                                }
                            }
                        }
                    }
                    .video-list2 {
                        display: grid;
                        flex-flow: wrap;
                        grid-template-columns: repeat(auto-fill,360px);
                        justify-content: space-between;
                        width: 1180px;
                        color: #fff;
                        .video {
                            width: 360px;
                            height: 360px;
                            margin: 40px 0px 0 0;
                            border-radius: 2px;
                            // cursor: pointer;
                            overflow: hidden;
                            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                            border-radius: 8px;
                            background: #fff;
                            > .img {
                                display: none;
                            }
                            > .topic {
                                position: absolute;
                                left: 10px;
                                top: 12px;
                                font-size: 12px;
                                line-height: 17px;
                            }
                            > .name {
                                width: 100%;
                                height: 80px;
                                padding: 0 24px;
                                line-height: 80px;
                                background-image: linear-gradient(156deg, #56AFFF 0%, #A3C6FF 100%);
                                text-align: left;
                                font-family: PingFangSC-Regular;
                                font-weight: 400;
                                font-size: 24px;
                                color: #FFFFFF;
                                // transform: translate(-50%, -50%);
                            }
                            .video-right {
                                display: none;
                            }
                            .video-item {
                                width: 100%;
                                height: 280px;
                                background-color: #ffffff;
                                padding: 24px;
                                overflow: auto;
                                &::-webkit-scrollbar {
                                    width: 6px;
                                    height: 4px;
                                    background-color: lighten(#DCDEE5, 80%);
                                }
                                &::-webkit-scrollbar-thumb {
                                    height: 2px;
                                    border-radius: 2px;
                                    background-color: #DCDEE5;
                                }
                                li {
                                    cursor: pointer;
                                    height: 24px;
                                    margin-bottom: 24px;
                                    color: #63656E;
                                    display: flex;
                                    align-items: center;
                                    span {
                                        &:nth-child(2) {
                                            overflow: hidden;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                        }
                                    }
                                }
                            }
                            &:nth-child(4n + 4) {
                                margin-right: 0;
                            }
                        }
                    }
                    .video-list3 {
                        display: grid;
                        flex-flow: wrap;
                        grid-template-columns: repeat(auto-fill,556px);
                        justify-content: space-between;
                        width: 1180px;
                        color: #fff;
                        .video {
                            width: 556px;
                            height: 120px;
                            margin: 24px 0px 0 0;
                            border-radius: 2px;
                            cursor: pointer;
                            overflow: hidden;
                            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                            background: #fff;
                            display: flex;
                            position: relative;
                            > .img {
                                width: 240px;
                                height: 120px;
                                float: left;
                            }
                             > .cover {
                                display: none;
                            }
                            > .name {
                                display: none;
                            }
                            .video-right {
                                width: 316px;
                                height: 120px;
                                float: left;
                                padding: 0 16px;
                                .name {
                                    width: 100%;
                                    height: 60px;
                                    font-family: PingFangSC-Regular;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #313238;
                                    display: flex;
                                    align-items: center;
                                    line-height: 30px;
                                    span {
                                        text-overflow: -o-ellipsis-lastline;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 2;
                                        line-clamp: 2;
                                    }
                                }
                                .tag-time {
                                    height: 60px;
                                    width: 100%;
                                    padding: 20px 0;
                                    .tag {
                                        padding: 2px 10px;
                                        height: 20px;
                                        color: #14A568;
                                        background: #E4FAF0;
                                        border: 1px solid rgba(20,165,104,0.30);
                                        border-radius: 2px;
                                        font-size: 12px;
                                        margin-right: 8px;
                                    }
                                    .advanced {
                                        color: #ffb542;
                                        background: rgba(255,232,195,0.60);
                                        border: 1px solid rgba(254,156,0,0.30);
                                    }
                                    .time {
                                        font-family: PingFangSC-Regular;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #979BA5;
                                    }
                                }
                            }
                            &:nth-child(4n + 4) {
                                margin-right: 0;
                            }
                        }
                    }
                    .video-list1 {
                        display: grid;
                        flex-flow: wrap;
                        grid-template-columns: repeat(auto-fill,570px);
                        justify-content: space-between;
                        width: 1180px;
                        color: #fff;
                        .video {
                            width: 570px;
                            height: 290px;
                            margin: 40px 0px 0 0;
                            border-radius: 2px;
                            cursor: pointer;
                            overflow: hidden;
                            box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
                            background: #fff;
                            > .img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }
    }

</style>

<style lang="scss">
    .cascader-popper {
        width: auto !important;
        padding: 0;
        .cascader-panel {
            display: flex;
            align-items: flex-start;
            font-size: 12px;
            .cascader-menu {
                height: 100%;
                padding: 15px 20px;
                border-left: 1px solid #dcdee5;
                &:first-child {
                    border-left: none;
                }
            }
        }
        dl {
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 32px;
            cursor: pointer;
            .anger-right-icon {
                display: inline-block;
                height: 18px;
                width: 18px;
                background: url('../../images/video/angle-right.png');
                background-size: 100% 100%;
            }
            &:hover, &.is-active {
                color: #3a84ff;
                .anger-right-icon {
                    background: url('../../images/video/angle-right1.png');
                    background-size: 100% 100%;
                }
            }
        }
    }
    .pro-video-dialog {
        .el-dialog__header {
            padding: 0;
            .el-dialog__headerbtn {
                top: 10px;
                right: 16px;
                font-size: 18px;
                z-index: 99;
                &:hover .el-icon-close {
                    color: #3a84ff;
                }
            }
        }
        .el-dialog__body {
            padding: 0;
            height: 500px;
            video {
                min-height: 500px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?3fefab8a